/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

 import { LogLevel, Configuration, BrowserCacheLocation } from '@azure/msal-browser';
 import { environment } from '../environments/environment';

 const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

 /**
  * Configuration object to be passed to MSAL instance on creation.
  * For a full list of MSAL.js configuration parameters, visit:
  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
  */

//   let value = 100;
//   console.log(`The size is ${ value }`);

 export const msalConfig: Configuration = {
     auth: {
         clientId: `${environment.adminToolClientId}`, // This is the ONLY mandatory field that you need to supply.
         authority: `https://login.microsoftonline.com/${environment.adminToolTenentId}`, // Defaults to "https://login.microsoftonline.com/common"
         redirectUri: '/', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
         postLogoutRedirectUri: '/', // Points to window.location.origin by default.
         clientCapabilities: ['CP1'] // This lets the resource server know that this client can handle claim challenges.
     },
     cache: {
         cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
         storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
     },
     system: {
         /**
          * Below you can configure MSAL.js logs. For more information, visit:
          * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
          */
         loggerOptions: {
             loggerCallback(logLevel: LogLevel, message: string) {
                 //console.log(message);
             },
             logLevel: LogLevel.Verbose,
             piiLoggingEnabled: false
         }
     }
 }

 /**
  * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
  */
 export const protectedResources = {
    itemsEndpoint: {
        endpoint: `${environment.apiBaseUrl}`,
        scopes: [environment.appRegScope]
    },
    // TODO I do not like this approach but it will have to do for now.
    itemsEndpointV2: {
        endpoint: `${environment.apiBaseUrl.replace('/v1/', '/v2/')}`,
        scopes: [environment.appRegScope]
    },
    itemsEndpointV3: {
        endpoint: `${environment.apiBaseUrl.replace('/v1/', '/v3/')}`,
        scopes: [environment.appRegScope]
    },
 }

 /**
  * Scopes you add here will be prompted for user consent during sign-in.
  * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
  * For more information about OIDC scopes, visit:
  * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
  */
 export const loginRequest = {
     scopes: [...protectedResources.itemsEndpoint.scopes]
 };

 export const roles = {
    AdminToolReader: "ItemRegistry.Read",
    AdminToolAdmin: "ItemRegistry.Admin",
    AdminToolWrite: "ItemRegistry.Write",
    AISearch: "ItemRegistry.AISearch"
 }
